import React from "react";
import Contact from "../components/Contact";
import Socials from "../components/Socials";

const ContactPage = () => (
  <div className="pt-20">
    <Contact />
    <Socials />
  </div>
);

export default ContactPage;
